import { z } from "zod";

export const SetCreatorBlockStatusSchema = z.object({
  creatorId: z.string().regex(/^[a-f0-9]{24}$/i, "Invalid creator ID"),
  blocked: z.boolean(),
});

export type SetCreatorBlockStatusDto = z.infer<
  typeof SetCreatorBlockStatusSchema
>;
